import classnames from 'classnames';
import * as React from 'react';
import { base, kind } from './pill.css.js';

/**
 * Displays a generic kind of status.
 */
const Pill = ({ children, className, kind: kind$1 = 'neutral', ...rest }) => {
    return (React.createElement("span", { ...rest, className: classnames(base, kind[kindMap[kind$1]], className) }, children));
};
const kindMap = {
    neutral: 'neutral',
    /**
     * @deprecated
     */
    primary: 'info',
    info: 'info',
    danger: 'danger',
    success: 'success',
    warning: 'warning',
};

export { Pill };
